import { QuotaWithUsage } from 'src/app/core/models/tariff.interface';
import { Convertor } from 'src/app/core/utils/convertor';

export function canInviteByQuota(
  companyQuotas: QuotaWithUsage[],
  quotaKey: string,
  currentUsage: number,
): boolean {
  const targetQuota = companyQuotas.find(
    (quota) =>
      Convertor.normalizeQuotaKey(quota.key) ===
      Convertor.normalizeQuotaKey(quotaKey),
  );

  if (!targetQuota) {
    return false;
  }

  return targetQuota.limit > currentUsage;
}
